import { useEffect, useState } from "react";
import { http, getToken, setToken } from "@/lib/api";
import { AdminLogin } from "@/components/admin/AdminLogin";
import { AdminDashboard } from "@/components/admin/AdminDashboard";

export default function Admin() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    if (!getToken()) { setUser(false); return; }
    http.get("/auth/me").then((r) => setUser(r.data)).catch(() => { setToken(null); setUser(false); });
  }, []);

  const logout = async () => {
    try { await http.post("/auth/logout"); } catch { /* ignore */ }
    setToken(null);
    setUser(false);
  };

  if (user === null) return <div className="min-h-screen bg-[#F7F9FC]" data-testid="admin-loading" />;
  return user ? <AdminDashboard user={user} onLogout={logout} /> : <AdminLogin onLogin={setUser} />;
}
